<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>可提佣金</div>
        <router-link class="record" :to="'/user/cashrecord'">
          提现记录<span class="iconfont icon-xiangyou"></span>
        </router-link>
      </div>
      <div class="num">{{ userInfo.extractPrice || 0 }}</div>
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>待审提现</div>
          <div class="money">{{ userInfo.extractWillPrice || 0 }}</div>
        </div>
        <div class="item">
          <div>累积已提</div>
          <div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即提现</div>
    <div class="list acea-row row-between-wrapper">
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/poster'"
      >
        <span class="iconfont icon-erweima"></span>
        <div>我的名片</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_list'"
      >
        <span class="iconfont icon-tongji"></span>
        <div>我的团队</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission_month'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>佣金明细</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/income_month'"
      >
        <span class="iconfont icon-dingdan"></span>
        <div>业绩明细</div>
      </router-link>
      <!--<router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_rank'"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>佣金排行</div>
      </router-link>-->
    </div>
  </div>
</template>
<script>
import { getUser } from "../../../api/user";
import { isWeixin } from "@utils";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
    this.setOpenShare();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
          console.log(that.userInfo);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    toCash: function() {
      this.$router.push({ path: "/user/user_cash" });
    },setOpenShare() {
      if (isWeixin()) {


        getUser().then(res => {
          var href = location.href;

          href =
                  href.indexOf("?") === -1
                          ? href + "?spread=" + res.data.uid
                          : href + "&spread=" + res.data.uid;
          var nickname = res.data.nickname;


          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: '['+nickname+'邀请] '+data.synopsis,
              title: data.title,
              link: href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        })



      }
    }
  }
};
</script>
